<template>
  <div id="app" v-loading="setLoading">
    <Header class="header"></Header>
    <router-view />
    <Footer
      class="my_footer"
      v-if="
        $route.path == '/' ||
        $route.path == '/about' ||
        $route.path == '/networkMarket' ||
        $route.path == '/server' ||
        $route.path == '/news' ||
        $route.path == '/listOfCases' ||
        $route.path == '/serverDetail'
      "
    ></Footer>
  </div>
</template>

<script>
import { getBackground, getFloorList, getConfig } from "./http/api.js";
export default {
  name: "App",
  components: {},
  computed: {
    setLoading() {
      return this.$store.state.setLoading;
    },
  },
  async mounted() {
    await getBackground().then((res) => {
      this.$store.commit("baclgroundInfo", res.data);
    });
    await getFloorList().then((res) => {
      this.$store.commit("floorData", res.data);
      localStorage.setItem("floorData", JSON.stringify(res.data));
    });
    await getConfig().then((res) => {
      this.$store.commit("ConfigData", res.data);
    });
  },
};
</script>
<style lang="scss">
@import "./assets/css/index";
* {
  margin: 0;
  padding: 0;
  cursor: url('./assets/cursor.png');
}
.imgW img{
width: auto;
}
#inddex {
  overflow: hidden !important;
}
.header {
  position: fixed;
  top: 0;
  z-index: 9;
}
.my_footer {
  z-index: 99;
  position: absolute;
  bottom: 0;
}
#FloorBannerPage {
  .swiper-pagination .swiper-pagination-bullet:focus {
    outline: none;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: auto;
  }
}

.el-carousel::-webkit-scrollbar {
  display: none !important;
}

.TianYuanfirst {
  .pagination {
    position: absolute;
    bottom: 115px !important;
    z-index: 99;
    width: 100%;
    display: flex;
    width: 100vw !important;
    justify-content: center;
    .swiper-pagination-bullet {
      width: 142px;
      height: 1px;
      background: #ffffff;
      margin: 0 42px !important;
    }
    .swiper-pagination-bullet-active {
      width: 142px;
      height: 1px;
      background: #ffffff;
    }
    .swiper-pagination-bullet-active::after {
      content: "";
      display: inline-block;
      animation: myafter 5s linear;
      background-color: #0fffff;
      width: 0;
      position: absolute;
      top: 0;
      height: 1px;
    }
    @keyframes myafter {
      0% {
        width: 0;
      }
      100% {
        width: 142px;
      }
    }
  }
}

#FloorBannerPage {
  .swiper-pagination {
    position: absolute;
    right: 50px;
    .swiper-pagination-bullet {
      margin: 60px 0;
      width: 4px;
      height: 4px;
      background: #ffffff;
      opacity: 1;
      color: transparent;
      border-radius: 50%;
      position: relative;
      cursor: pointer  !important;
    }

    .swiper-pagination-bullet .swiperspan {
      display: none;
      transition: all 0.5s;
    }

    .swiper-pagination-bullet:focus {
      outline: none;
    }

    .swiper-pagination-bullet {
      .top {
        display: none;
      }
      .bottom {
        display: none;
      }
    }

    .swiper-pagination-bullet:last-child {
      .bottom {
        display: none !important;
      }
    }
    .swiper-pagination-bullet:first-child {
      .top {
        display: none !important;
      }
    }

    .swiper-pagination-bullet::before {
      content: "......." !important;
      display: inline-block !important;
      writing-mode: tb-rl !important;
      width: 1px;
      position: absolute;
      // right: -14px;
      right: -9px;
      top: 18px;
      color: #ffffff;
    }
    .swiper-pagination-bullet:last-child::before {
      display: none !important;
    }

    .swiper-pagination-bullet-active::before {
      position: absolute;
      // right: -7px;
      right: -2px;
      top: 40px;
    }
    .swiper-pagination-bullet-active {
      position: relative;
      padding: 5px;
      border: 1px solid #0fffff;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      transform: translateX(-10px);
      background: transparent;
      .swiperspan {
        display: inline-block;
        position: absolute;
        right: 40px;
        font-size: 14px;
        font-family: Arial;
        font-weight: bold;
        line-height: 34px;
        color: #0fffff;
        top: -7px;
        transition: all 0.5s;
      }
      .top {
        display: inline-block;
        color: #fff;
        position: absolute;
        top: -25px;
        right: 4px;
      }
      .bottom {
        display: inline-block;
        color: #fff;
        position: absolute;
        bottom: -20px;
        right: 4px;
      }
      .dian {
        display: inline-block !important;
        width: 10px !important;
        height: 10px !important;
        background: #0fffff !important;
        border-radius: 50% !important;
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }
  }
  // .FloorSecond{
  //   .carousel_box{
  //     .is-active{
  //       width:988px !important;
  //     }
  //   }
  // }
}

#TianYuanBannerPage {
  .swiper-pagination {
    position: absolute;
    right: 50px;
    .swiper-pagination-bullet {
      margin: 60px 0;
      width: 4px;
      height: 4px;
      background: #ffffff;
      opacity: 1;
      border-radius: 50%;
      position: relative;
      cursor: pointer  !important;
    }

    .swiper-pagination-bullet .swiperspan {
      display: none;
      transition: all 0.5s;
    }

    .swiper-pagination-bullet:focus {
      outline: none;
    }

    .swiper-pagination-bullet {
      .top {
        display: none;
      }
      .bottom {
        display: none;
      }
    }

    .swiper-pagination-bullet:last-child {
      .bottom {
        display: none !important;
      }
    }
    .swiper-pagination-bullet:first-child {
      .top {
        display: none !important;
      }
    }

    .swiper-pagination-bullet::before {
      content: "......." !important;
      display: inline-block !important;
      writing-mode: tb-rl !important;
      width: 1px;
      position: absolute;
      right: -9px;
      top: 18px;
      color: #ffffff;
    }
    .swiper-pagination-bullet:last-child::before {
      display: none !important;
    }

    .swiper-pagination-bullet-active::before {
      position: absolute;
      right: -2px;
      top: 40px;
    }
    .swiper-pagination-bullet-active {
      position: relative;
      padding: 5px;
      border: 1px solid #0fffff;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      transform: translateX(-10px);
      background: transparent;
      .swiperspan {
        display: inline-block;
        position: absolute;
        right: 40px;
        font-size: 14px;
        font-family: Arial;
        font-weight: bold;
        line-height: 34px;
        color: #0fffff;
        top: -7px;
        transition: all 0.5s;
      }
      .top {
        display: inline-block;
        color: #fff;
        position: absolute;
        top: -25px;
        right: 4px;
      }
      .bottom {
        display: inline-block;
        color: #fff;
        position: absolute;
        bottom: -20px;
        right: 4px;
      }
      .dian {
        display: inline-block !important;
        width: 10px !important;
        height: 10px !important;
        background: #0fffff !important;
        border-radius: 50% !important;
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }
  }
}
.DevelopmentHistory {
  .control_box {
    .pagi_box {
      .swiper-pagination {
        width: 750px;
        height: 120px;
        display: flex;
      overflow-x: auto !important;
        justify-content: center;
        .swiper-pagination-bullet {
          display:block;
          width: 100px;
          height: 120px;
          border-radius: 0;
          border-left: 1px solid #c8c8c8;
          background: transparent;
          opacity: 1;
          transition: all 0.5s;
          margin-left: 20px !important;
          span {
            display: block;
            width: 100%;
            height: 120px;
            text-align: center;
            line-height: 120px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c8c8c8;
            transition: all 0.5s;
          }
        }
        .swiper-pagination-bullet:focus {
          outline: none;
        }
        .swiper-pagination-bullet-active {
          display: inline-block;
          width: 100px;
          height: 120px;
          border-radius: 0;
          border-left: 1px solid #0fffff;
          background: transparent;
          transition: all 0.5s;
          span {
            display: block;
            width: 100%;
            height: 120px;
            text-align: center;
            line-height: 120px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0fffff;
            transition: all 0.5s;
          }
        }
      }
    }
    .min_swiper{
      .swiper-slide-active{
         border-left: 1px solid #0fffff;
         .min_text{
           color: #0fffff !important;
         }
      }
    }
  }
}
.problem {
  .el-collapse-item__header {
    background: transparent !important;
    // color: #ffffff;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #ffffff;
    height: 80px !important;
  }
  .el-collapse-item__wrap {
    background: transparent !important;
    .el-collapse-item__content {
      color: #ffffff !important;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      color: #ffffff;
    }
  }
}
</style>
